import React from "react";

import { Button, Popover, Stack } from "@mui/material";

interface Props {
  open: boolean;
  anchorEl: HTMLElement | null | undefined;
  onClose: () => void;
  onApply: () => void;
  children: React.ReactNode;
}

export const CellEditPopover: React.FC<Props> = ({ open, anchorEl, onClose, onApply, children }) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
    slotProps={{
      paper: {
        sx: {
          borderRadius: "8px",
          boxShadow: "-2px 2px 15px 0px rgba(0,0,0,0.25)",
          width: 379,
          p: "24px"
        }
      }
    }}
  >
    <Stack gap="16px">
      {children}
      <Stack direction="row" justifyContent="flex-end" gap="8px">
        <Button
          onClick={onClose}
          sx={{
            borderRadius: "32px",
            border: "1px solid #7b92a9",
            color: "#071f35",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onApply}
          sx={{
            borderRadius: "32px",
            bgcolor: "#071f35",
            color: "white",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            "&:hover": { bgcolor: "#0a2a45" }
          }}
        >
          Apply
        </Button>
      </Stack>
    </Stack>
  </Popover>
);
